require(["jquery", "bootstrap", "kendoInlineScripts"], function ($) {
    $(function () {
        var videoWindow = $("#videoWindow"),
            dashboardTour = $("#dashboardTour");

        var videoSrc = $("#hdnQuickHelpVideoUrl").attr("data-url");;

        dashboardTour.click(function () {
            videoWindow.data("kendoWindow").center().open();
            $("#dashboardVideo").attr("src", videoSrc);
        });

        function onClose() {
            $("#dashboardVideo").attr("src", "");
        }

        videoWindow.kendoWindow({
            title: "iAccess Dashboard Tour",
            visible: false,
            actions: [
                "Close"
            ],
            close: onClose
        }).data("kendoWindow");
    });
});